import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import request from 'superagent';

var fixResponse = function fixResponse(response) {
  if (response && response.text) return JSON.parse(response.text).d;
  return response;
};

var token = '';

var getBaatToken = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(baseUrl) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return request.get(baseUrl + 'WebServices/generic/Baat.ashx')
            // .get('http://localhost/a_a3/WebServices/generic/Baat.ashx')
            .set('Accept', 'application/json');

          case 3:
            response = _context.sent;

            if (response && response.body && response.body.success && response.body.token) {
              token = response.body.token;
            } else {
              console.error('Could not load baat-token');
            }
            return _context.abrupt('return', token);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);

            console.error('Could not load baat-token', _context.t0);
            return _context.abrupt('return', token);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 8]]);
  }));

  return function getBaatToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { getBaatToken };